import { FeatureFlag } from '@signup/shared';
import * as React from 'react';
import { isFeatureEnabled } from '../../utils/configurations';
import { useWindowsOrNot } from '../../utils/useWindowsOrNot';
import { CortexInstallBlockV2 } from './CortexInstallBlockV2';
import { TerminalCodeBlock, TerminalTab } from './TerminalCodeBlock';

const CORTEX_INSTALL_TABS: TerminalTab[] = [
  {
    label: 'MacOS / Linux / Windows (WSL)',
    commands: [{ command: 'curl -LsS https://ai.snowflake.com/static/cc-scripts/install.sh | sh' }],
  },
  {
    label: 'Windows (Native)',
    commands: [
      {
        command: 'irm https://ai.snowflake.com/static/cc-scripts/install.ps1 | iex',
      },
    ],
  },
];

export const CortexInstallBlock = () => {
  const platform = useWindowsOrNot();
  if (isFeatureEnabled(FeatureFlag.FF_ENABLE_CORTEX_CODE_2026)) {
    return <CortexInstallBlockV2 />;
  }
  return (
    <TerminalCodeBlock tabs={CORTEX_INSTALL_TABS} defaultTab={platform === 'windows' ? 1 : 0} />
  );
};
